import {MolecularGraph} from "../../graph/MolecularGraph"
import {alcoholExtractor} from "./alcoholExtractor";
import {alkeneExtractor} from "./alkeneExtractor";
import {alkineExtractor} from "./alkineExtractor";
import {alkylHalideExtrator} from "./alkylHalideExtrator";
import {amineExtractor} from "./amineExtractor";
import {carbonylExtractor} from "./carbonylExtractor";
import {etherExtractor} from "./etherExtractor";
import {sulfideExtractor} from "./sulfideExtractor";
import {thiolExtractor} from "./thiolExtractor";
import {amineFilter} from "../../filter/amineFilter";
import {etherFilter} from "../../filter/etherFilter";
import {nitroExtractor} from "./nitroExtractor";
import {nitrileExtractor} from "./nitrileExtractor";

export const functionalGroupExtractor = {
    extract: (graph: MolecularGraph) => {
        const features = [
            ...alcoholExtractor.extract(graph),
            ...alkeneExtractor.extract(graph),
            ...alkineExtractor.extract(graph),
            ...alkylHalideExtrator.extract(graph),
            ...amineExtractor.extract(graph),
            ...carbonylExtractor.extract(graph),
            ...etherExtractor.extract(graph),
            ...sulfideExtractor.extract(graph),
            ...thiolExtractor.extract(graph),
            ...nitroExtractor.extract(graph),
            ...nitrileExtractor.extract(graph),
        ];

        // Filter step
        const filters = [amineFilter, etherFilter]
        filters.forEach(f => f.filterInPlace(features));

        return features;

    }
}
